<div #feedbackButton
     (click)="openFeedbackDialog()"
     class="feedback-button"
     [style.top]="'calc(50% - ' + (feedbackButton.clientHeight / 2) + 'px)'"
     [style.right.px]="getPositionRight(feedbackButton.clientWidth, feedbackButton.clientHeight)">
  <mat-icon svgIcon="feedback"/>
  <span>Feedback</span>
</div>


